import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './LightIcon.module.css';

const colorClass = {
    primary: styles.primary,
    secondary: styles.secondary,
    secondary_emphasized: styles.secondaryEmphasized,
    lightGray: styles.lightGray,
    superLightGray: styles.superLightGray,
    error: styles.error,
    white: styles.white,
    white_base: styles.whiteBase,
};

export const LightIcon = ({ rightIndent, leftIndent, color, size, name }) => {
    const style = { '--icon-size': size, marginRight: rightIndent, marginLeft: leftIndent };

    return (
        <span className={clsx(styles.icon, color && colorClass[color])} style={style}>
            <svg>
                <use xlinkHref={`/i/promo-svg-icons/promo-icons.svg#${name}`} />
            </svg>
        </span>
    );
};

LightIcon.propTypes = {
    name: PropTypes.string,
    color: PropTypes.oneOf(['primary', 'secondary', 'secondary_emphasized', 'lightGray', 'superLightGray', 'error', 'white', 'white_base']),
    size: PropTypes.oneOf(['16px', '20px', '24px', '32px', '48px', '56px', '64px', '80px', '96px', '100%']),
    rightIndent: PropTypes.oneOf(['4px', '8px', '12px', '16px', '24px', '32px']),
    leftIndent: PropTypes.oneOf(['4px', '8px', '12px', '16px', '24px', '32px']),
};
